// frontend/source/portal/components/CreateArtTagCard.js
import React, { useState } from "react";
import ImagePicker from "./ImagePicker";
import ConfirmDialog from "./ConfirmDialog";
import "./CreateArtTagCard.css";

const CreateArtTagCard = ({ onCreate }) => {
  const [isCreating, setIsCreating] = useState(false);
  const [name, setName] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [showImagePicker, setShowImagePicker] = useState(false);
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);

  const handleStartCreate = () => {
    setIsCreating(true);
  };

  const handleCancel = () => {
    if (name.trim() !== "" || selectedImage) {
      setShowCancelConfirm(true);
    } else {
      resetForm();
    }
  };

  const confirmCancel = () => {
    resetForm();
    setShowCancelConfirm(false);
  };

  const resetForm = () => {
    setIsCreating(false);
    setName("");
    setSelectedImage(null);
  };

  const handleSave = async () => {
    if (name.trim() === "") {
      alert("Art tag name cannot be empty");
      return;
    }

    if (!selectedImage) {
      alert("Please select an image for the art tag");
      return;
    }

    try {
      setIsSaving(true);
      await onCreate({ name: name.trim(), image: selectedImage });
      setName("");
      setSelectedImage(null);
      setIsCreating(false);
    } catch (err) {
      console.error("Failed to create art tag:", err);
    } finally {
      setIsSaving(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  const handleImageSelect = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  if (!isCreating) {
    return (
      <div className="create-arttag-card" onClick={handleStartCreate}>
        <div className="create-arttag-placeholder">
          <div className="create-arttag-icon">+</div>
          <h2 className="create-arttag-text">Add New Art Tag</h2>
        </div>
      </div>
    );
  }

  return (
    <div className="create-arttag-card creating">
      <div className="create-arttag-card-image-container">
        {selectedImage ? (
          <>
            <img
              src={selectedImage}
              alt="Selected art tag"
              className="create-arttag-card-image"
            />
            <button
              onClick={() => setShowImagePicker(true)}
              className="create-arttag-change-image-btn"
              title="Change image"
              disabled={isSaving}
            >
              📷
            </button>
          </>
        ) : (
          <div
            className="create-arttag-image-placeholder"
            onClick={() => setShowImagePicker(true)}
          >
            <div className="create-arttag-image-icon">🖼️</div>
            <p>Click to select image</p>
          </div>
        )}
      </div>

      <div className="create-arttag-card-overlay">
        <div className="create-arttag-input-container">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={handleKeyPress}
            className="create-arttag-input"
            placeholder="Art tag name"
            autoFocus
            disabled={isSaving}
          />
          <div className="create-arttag-buttons">
            <button
              onClick={handleSave}
              className="create-arttag-btn save-btn"
              disabled={isSaving || !name.trim() || !selectedImage}
            >
              {isSaving ? "Creating..." : "Create"}
            </button>
            <button
              onClick={handleCancel}
              className="create-arttag-btn cancel-btn"
              disabled={isSaving}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      {showImagePicker && (
        <ImagePicker
          currentImage={selectedImage}
          onImageSelect={handleImageSelect}
          onClose={() => setShowImagePicker(false)}
        />
      )}

      <ConfirmDialog
        isOpen={showCancelConfirm}
        title="Discard Changes?"
        message="You have unsaved changes. Are you sure you want to cancel creating this art tag?"
        confirmText="Discard"
        cancelText="Keep Editing"
        type="warning"
        onConfirm={confirmCancel}
        onCancel={() => setShowCancelConfirm(false)}
      />
    </div>
  );
};

export default CreateArtTagCard;
